<template>
  <div class="top_case">

      <div class="top_case-one">
        <div class="text item infodiv">
            <div class="infos-l">
              <img :src="$store.getters.getUserInfo.avatar" class="infoimg">
            </div>
            <div class="infos-r">
              <div class="top_case_title">HI,{{ $store.getters.getUserInfo.username }}</div>
              <div class="text item codeInfo">
		<span class="mflag">余额:</span><span class="money">{{ balance }}</span>
		<router-link tag="a" :to="'/account/recharge'"><span class="item-l">充值</span></router-link>
              </div>
            </div>
        </div>
      </div>

<!-- 功能列表 部分 开始 -->

      <div class="top_case-one">
        <div class="top_case-s">
	  <div class="info-w">
	    <img src="~assets/icons/wx_r-50.png"  class="info-w_img">
	    有问题找客服，微信号：
	    <span id="wx_service" v-if="$store.getters.getSiteInfo.wx_service !== ''" v-clipboard:copy="$store.getters.getSiteInfo.wx_service" v-clipboard:success="onCopy" v-clipboard:error="onError" >
	      {{ $store.getters.getSiteInfo.wx_service }}

	      <img src="~assets/icons/copy4.png" class="info-w_img2" />
	    </span>
	  </div>
	  <div class="menu-l">
	    <ul>
	      <li>
		<a href="/m/orderAdmin/purchase">
	        <div class="mli-img"><img src="~assets/icons/1xiadan.png"></div>
		<div class="mli-tt">礼品下单</div>
		</a>
	      </li>
<!-- 
	      <li>
		<a href="/m/orderAdmin/purchaseNosource">
	        <div class="mli-img"><img src="~assets/icons/nosource.png"></div>
		<div class="mli-tt">无货源单</div>
		</a>
	      </li>
-->
	      <li>
		<a href="/m/orderAdmin/purchaseFast">
	        <div class="mli-img"><img src="~assets/icons/fastsend.png"></div>
		<div class="mli-tt">快速下单</div>
		</a>
	      </li>
	      <li>
		<a href="/m/orderAdmin/orderList">
	        <div class="mli-img"><img src="~assets/icons/2dingdan.png"></div>
		<div class="mli-tt">订单管理</div>
		</a>
	      </li>
	      <li>
		<a href="/m/orderAdmin/parcelList">
	        <div class="mli-img"><img src="~assets/icons/3baoguo.png"></div>
		<div class="mli-tt">包裹管理</div>
		</a>
	      </li>
	      <li>
		<a href="/m/orderAdmin/storeBind">
	        <div class="mli-img"><img src="~assets/icons/storebind.png"></div>
		<div class="mli-tt">绑定店铺</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/recharge">
	        <div class="mli-img"><img src="~assets/icons/5congzhi.png"></div>
		<div class="mli-tt">充值</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/capitalFlow">
	        <div class="mli-img"><img src="~assets/icons/6zhijing.png"></div>
		<div class="mli-tt">资金明细</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/cashout">
	        <div class="mli-img"><img src="~assets/icons/withdraw.png"></div>
		<div class="mli-tt">奖金提现</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/inviteFriends">
	        <div class="mli-img"><img src="~assets/icons/7fenxiang.png"></div>
		<div class="mli-tt">推广分享</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/base">
	        <div class="mli-img"><img src="~assets/icons/8guorenziliao.png"></div>
		<div class="mli-tt">个人信息</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/realnameAuth">
	          <div class="mli-img"><img src="~assets/icons/9shiming.png"></div>
	          <div class="mli-tt">实名认证</div>
		</a>
	      </li>
	    </ul>
	  </div>
        </div>
      </div>
    <div class="notice_case" style="margin-top:10px;">
      <div class="noticett">
	<i></i><span>网站公告</span>
	<a href="/m/notice/noticelist">更多>></a>
      </div>
      <div class="noticelist">
	    <ul>
	      <li v-for="(nItem, nKey) in noticeHot">
		<a href="javascript:;"  @click="showNotice(nItem.id)">
		<span class="tm">{{ timeConverDate(nItem.createtime) }}</span>
	        <div class="litt">{{ nItem.title }}</div>
		</a>
	      </li>
	    </ul>
      </div>
    </div>
  <!-- 显示公告详情 -->
    <el-dialog  :title="noticeDetail.title" :visible.sync="noticeDivShow" center :before-close="noticeDivClose" width="90%" top="50px">
      <div :model="noticeInfo">

        <div class="info">
          <div class="info-content" v-html="noticeDetail.content"></div>
        </div>
        <div class="addtime">
          <span>发布时间：{{timeConverDate(noticeDetail.createtime)}}</span><span class="sdf" style="margin-left:15px">{{$store.getters.getSiteInfo.name}}</span>
        </div>
      </div>
    </el-dialog>

<!-- 功能列表 部分 结束 -->

    <app-main />
      
    </div>
  </div>
</template>

<script>
import { timeConversion, timeConverDate } from 'utils/utils'
import { moneyInfo, getSubTrad, getNoticeDetail, getTopNotice, getNoticeSelect, loadNoticeByPos, statusNum, inviteHttp, selectAll, deliverPrice, groupList, getsuperadsbytag, getAward } from 'network/api'
import AppMain from '../../../components/baseStructure/AppMain.vue'
//import TopUp from '../../../components/TopUp.vue'
//import AdminHeader from 'components/baseStructure/AdminHeader'
// import NoticeList from '../../../components/notice/noticelist.vue'
// import NoticeDetail from '../../../components/notice/noticedetail.vue'
import Cookies from 'js-cookie'
export default {
  inject: ['reload'],
  components: {
//  AdminHeader
    AppMain
//    TopUp
//	NoticeList,
//	NoticeDetail
  },
  data () {
    return {
      o: '\u00a0\u00a0\u00a0\u00a0\u00a0',
      balance: '',
      // 公告
      notice: [],
      noticeTop: [],
      // 底部订单状态
      packInfo: {},
      // 邀请框
      url: '',
      language: '我发现一个电商人必备的礼品代发网站',
      people: '',
      arr: [],
      // 立即充值
      activeIndex: '0',
      dialogVisible: false,
      amountType: 'alipay',
      controls: false,
      num: undefined,
      gridData: [],
      dialogTableVisible: false,
      redialogVisible: false,
      imgUrl: '',
      input: '',
      balanceInfo: {},
      money: 0,
      styleObject: {
        color: 'red'
        // fontSize: '13px'
      },
      serverName: '',
      adslist: '',
      clickhref: '',
      groupData: '',
      awardName: null,
      awardUp: '',
      m: '000.00',
      loadNoticeByPos: [],
      isshow: true,
      noticeDetail: [],
      noticeDivShow: false,
      noticeId: 0,
      labelPosition:{},
      noticeInfo:{},
      noticeHot:{},
      noticeQuestion:{}
    }
  },
  created () {
    getAward().then((res) => {
      if (res.code !== 1) return
      this.awardName = res.data
    })
    // 顶部广告
    getsuperadsbytag({ tagname: 'purchase' }).then((res) => {
      if (res.code !== 1 && res.data.length === '') {
        return
      }
      if(res.data.adslist[0]){
        this.adslist = res.data.adslist[0]
        this.clickhref = res.data.adslist[0].clickhref
      }
    })
    // 余额
    this.getMoney()
    // 头部公告
    getTopNotice().then((res) => {
      this.noticeTop = res.data[0]
      this.notice = res.data
      this.notice.shift()
    })
    // 常见问题
    getNoticeSelect({tids: [2,3,4],pos: 2}).then((res) => {
      // this.noticeTop = res.data[0]
      this.noticeQuestion = res.data.data
      // this.notice.shift()
    })
    // 网址公告
    getNoticeSelect({typedata: 1,pos: 2}).then((res) => {
      // this.noticeTop = res.data[0]
      this.noticeHot = res.data.data
      // this.notice.shift()
    })
    // 订单状态
    statusNum()
      .then((res) => {
        // console.log(res, '----')
        if (res.code !== 1 || undefined) {
          return false
        }
        if (res.code === 1) {
          this.packInfo = res.data
        }
      })
      .catch((err) => {
        console.log(err)
      })

    // 邀请链接
    inviteHttp().then((res) => {
      if (res.code !== 1 && res.data.length === '') {
        return
      }
      // eslint-disable-next-line camelcase
      const frontend_url = this.$store.getters.getSiteInfo.frontend_url
      // console.log(this.$store.getters.getUserInfo)
      // eslint-disable-next-line camelcase
      this.url = this.language + frontend_url + '/register?user_id=' + res.data
      // console.log(this.url)
    })
    // 邀请用户信息
    selectAll().then((res) => {
      if (res.code === 0) {
        // eslint-disable-next-line no-return-assign
        return (this.people = 0)
      }
      this.people = res.data.length
    })
  },
  computed: {
    // 注册时间戳转换
    createtime () {
      return timeConversion(this.$store.getters.getUserInfo.createtime)
    },
    compute () {
      return Object.keys(this.$store.getters.getSiteInfo.server_server)[0]
    },
    comput () {
      return Object.values(this.$store.getters.getSiteInfo.server_server)[0]
    },
    // 使用时间戳转化函数
    timeConverDate() {
      return timeConverDate
    }
  },
  methods: {

    setcookie () {
      const d = new Date()
      d.setTime(d.getTime() + 6 * 60 * 60 * 1000)// 24小时
      // d.setTime(d.getTime() + 1 * 60 * 60 * 1000);//1小时
      // d.setTime(d.getTime() + 1 * 60 * 1000);//1分钟
      // ad=popup-ad   键值对形式：name=key   expires 有效期
      document.cookie = 'ad=popup-ad;expires= ' + d.toGMTString()
      const result = document.cookie
      return result
    },
    // 显示公告详情
    showNotice(id) {
      this.noticeId = id
      getNoticeDetail({id:this.noticeId}).then((res) => {
        this.noticeDetail = res.data
        this.noticeDivShow = true
      })
    },
    /*  关闭公告详情页 testarea   */
    noticeDivClose(){
      this.noticeDivShow = false
    },
    dialog () {
      loadNoticeByPos({
        position: 'usercenter'
      }).then((res) => {
        this.loadNoticeByPos = res.data
        this.dialogVisible = true
      })
    },
    mesg () {
      this.dialogVisible = false
      window.localStorage.setItem('mesg', '我知道了')
    },
    next () {
      this.dialogVisible = false
      localStorage.removeItem('mesg')
      Cookies.remove('ad')
    },
    getMoney () {
      moneyInfo().then((res) => {
        // eslint-disable-next-line no-cond-assign
        this.balance = res.data.balance
        this.money = res.data.ok_money
      })
    },
    goUp () {
      this.$router.push('/m/account/balance')
    },
    // activeItem () {
    refresh () {
      // console.log('余额')
      // this.reload()
      // this.refresh()
      this.getMoney()
    },
    // setTimeout(function () {
    //   this.reload()
    // }, 1000)
    // },
    // 提交充值按钮
    submit () {
      getSubTrad({ trade: this.input }).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: '充值成功',
            type: 'success'
          })
        } else {
          return this.$message.error({
            message: res.msg
          })
        }
      })
    },
    renovate () {
      moneyInfo().then((res) => {
        if (res.code === 1) {
          this.balanceInfo = res.data
          // console.log(res.data)
          this.$message({
            message: '刷新成功',
            type: 'success'
          })
        } else {
          this.$message.error({
            message: '刷新失败'
          })
        }
        // console.log(res)
      })
    },
    recharge () {
      this.redialogVisible = true
      this.imgUrl = this.$store.getters.getSiteInfo.alipay_paymentcode
    },
    // 广告点击跳转
    adsClick () {
      // window.open(this.clickhref)
    },
    // 复制成功时的回调函数
    onCopy() {
      this.$message.success('复制成功')
    },
    // 复制失败时的回调函数
    onError() {
      this.$message.error('复制失败')
    },
    // 更换邀请语
    change () {
      this.arr = this.$store.getters.getSiteInfo.invite_title || ''
      const index = Math.floor(Math.random() * this.arr.length)
      this.language = this.arr[index]
      inviteHttp().then((res) => {
        // eslint-disable-next-line camelcase
        const frontend_url = this.$store.getters.getSiteInfo.frontend_url
        // eslint-disable-next-line camelcase
        this.url = this.language + ',' + frontend_url + '/register?user_id=' + res.data
      })
    },
    // 马上充值
    showRecharge () {
      this.dialogVisible = true
    },
    closePayDialog () { },
    load () {
      deliverPrice().then((res) => {
        if (res.code === 1) {
          this.gridData = res.data
          // for (let i = 0; i < res.length; i++) {
          // }
        }
        // console.log(res)
      })
      groupList().then((res) => {
        if (res.code === 1) {
          this.groupData = res.data
          // for (let i = 0; i < res.length; i++) {
          // }
        }
        // console.log(res)
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    }
  },
  mounted () {
    this.load()
    const vers = localStorage.getItem('mesg')
    if (!vers) {
      if (!document.cookie.includes('ad=')) {
        this.setcookie()
        this.dialog()
        this.isshow = true
      } else {
        this.isshow = false
      }
    }
  }
}
</script>

<style  lang="scss" scope>

.awardUp {
  position: relative;
  margin-top: 50px;
}
.groupData {
  margin-top: 30px;
  // position: relative;
  // text-align: center;
  float: left;
  margin-left: 12%;
  font-size: 16px;
  justify-content: space-between;
  //  position: inline-block;
  color: #1890ff;
}

//顶部栏
.top_case {
  width: 100%;
}
.top_case-one{
  width: 100%;
  display: table;
}
.top_case-s{
  padding:10px 20px;
}
.top_case_title{
    font-family: "simhei","Microsoft Yahei","Times New Roman",Georgia,Serif;
    font-size: 20px;
    font-weight:bold;
    padding:10px 0 5px 10px;
    height:42px;
    line-height:42px;
    font-size:22px;
    color:#FFF;
}
.infodiv {
    margin-bottom: 14px;
    padding: 15px;
    display: flex;
    /*background-color:#e8e2eb;*/
/*
  width: 100%;
  height: 100%;*/
  background-image: url('~assets/images/top_bj_1.jpg');
  background-size: cover;
  background-repeat: no-repeat;
}
.infos-r {
    /* width:100%;*/
}
.infoimg{
    margin:5px 15px 0 5px;
    width:100px;
    height:100px;
    border-radius: 10px;
}
.info-w {
   border:1px solid #e0e0e0;
   border-radius: 5px;
   background-color:#f5faf1;
   padding: 6px;
   color: #569f29;
}
.info-w_img {
   width:26px !important;
   height:auto;
   vertical-align:middle;
   margin:0 5px 0 5px;
}
.info-w_img2 {
   width:20px !important;
   height:auto;
   vertical-align:middle;
   margin-left: 3px;
}
.menu-l{
   margin-top:25px;
   width:100%;
}
.menu-l li{
   float:left;
   width:33%;
   margin-bottom:20px;
}
.mli-img {
    padding:10px 0 5px 0;
    margin:10px;
    text-align:center;
    background-color:#f4f4f4;
    border-radius: 9px;
}
.mli-img img{
    width: 80%;
    height:auto;
}
.mli-tt{
    border-radius: 9px;
    text-align:center;
    font-size:16px;
    font-weight:bold;
    border-right:1px solid #FFF;
    line-height:20px;
}
.codeInfo{
    padding-left:10px;
    font-size:18px;
    height:36px;
    line-height:36px;
    color:#FFF;
}
.money,.mt,.mflag{
    font-size:20px;
    height:26px;
    line-height:26px;
}
.money{	margin-left:5px;}
.item-l {
    background-color:#ff8400;
    color:#FFF;
    font-size:16px;
    padding: 10px 20px;
    margin-left:20px;
    border-radius: 5px;
   white-space: nowrap;
}
.top_case-shadow {
  box-shadow: 0 2px 20px rgba(15, 41, 131, 0.1);
}


/* 卡片组件自带样式 */
.text.item {
  position: relative;
}
.text {
  font-size: 14px;
}
.clearfix {
  display: flex;
  padding-top:5px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
.clearfix .title{
    font-size:18px;
}

/* 充值Dialog */
.content-dialog {
  padding-left: 58px;
  padding-right: 58px;
}

.content-dialog .name {
  margin-bottom: 1em;
}

.content-dialog .price {
  margin-bottom: 1em;
  display: flex;
  align-items: center;
}

.content-dialog .price .packing {
  display: flex;
}

.content-dialog .price .packing .packing-item {
  cursor: pointer;
  width: 80px;
  height: 32px;
  border: 1px solid #d9d9d9;
  margin-right: 16px;
  border-radius: 4px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-dialog .price .packing .active {
  position: relative;
  border: 1px solid #1890ff;
}

.content-dialog .price .packing .packing-item.active .dagou {
  display: block;
}

.content-dialog .price .packing .packing-item .dagou {
  position: absolute;
  right: -1px;
  bottom: -1px;
  display: none;
}
/*  公告列表  开始	*/

.notice_case{
   display: inline;
   width:100%;
   display: table;
}
.noticett{
   padding-left:2%;
   height:45px;
   line-height:45px;
   border-bottom:1px solid #CCC;
}
.noticett span{
   width:48%;
   font-size:16px;
   font-weight:bold;
   display:inline-block;
}
.noticett a{
   width:42%;
   font-weight:normal;
   font-size:14px;
   color:#666;
   padding-top:4px;
   margin-right:2%;
   display:inline-block;
   text-align:right;
}
.noticett i{
   border-left: 3px solid #0099ff;
   height:18px;
   margin:10px;
}
.noticelist {
   padding:10px 15px;
}
.noticelist li{
   width:100%;
}
.litt{
   width: 75%;
   line-height:32px;
   color:#666;
   font-size: 16px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.noticelist .tm{
    float:right;
    line-height:32px;
    width:23%;
   white-space: nowrap;
}
.el-dialog__body{
    padding: 15px 15px 38px 15px !important;
}
.info-content{
    width:100%;
    margin-bottom:20px;
    font-size:16px;
    line-height:1.5;
}
.addtime{
    margin-bottom:20px;
    float:right;

}
/*  公告列表  结束	*/
</style>